/*

direct (direct=true, extern=true)
gemengd (direct=false, extern=true)
direct intern (direct=true, extern=false)
gemengd intern (direct=false, extern=false)
direct extern (direct=true, extern=true)
gemengd extern (direct=false, extern=true)


Not rendered:
- pomp_intern
- pomp_extern
*/

const CIRCUIT_TYPES = [
  {
    name: 'direct',
    direct: true,
    extern: true,
  },
  {
    name: 'gemengd',
    direct: false,
    extern: true,
  },
  {
    name: 'direct intern',
    direct: true,
    extern: false,
  },
  {
    name: 'gemengd intern',
    direct: false,
    extern: false,
  },
  {
    name: 'direct extern',
    direct: true,
    extern: true,
  },
  {
    name: 'gemengd extern',
    direct: false,
    extern: true,
  },
];
const CIRCUIT_TYPES_BY_NAME = {};

CIRCUIT_TYPES.forEach((circuitType) => {
  CIRCUIT_TYPES_BY_NAME[circuitType.name] = circuitType;
});

export {
  CIRCUIT_TYPES,
  CIRCUIT_TYPES_BY_NAME,
};



// WEBPACK FOOTER //
// ./js/utils/project-definition/circuit-types.js